import Button from "components/base/Button";
import { useModals } from "ModalProvider";
import { useState } from "react";
import { FaLink, FaLinkSlash } from "react-icons/fa6";
import LinkOdooProductMTView from "./LinkOdooProductMTView";

const ProductsView = ({ products }) => {
  const [selectedProductIds, setSelectedProductIds] = useState([]);

  const modal = useModals(0);

  function chooseProductToLink(product) {
    modal.present({
      title: "Choose INC Odoo Product to Link",
      subtitle: `[${product.itemNumber}] ${product.name}`,
      children: (
        <LinkOdooProductMTView
          instance="INC"
          product={product}
          hide={modal.hide}
        />
      ),
    });
  }

  return (
    <div>
      <table>
        <thead>
          <tr className="sticky top-0 bg-gray-50 dark:bg-gray-800 z-10">
            <th className="w-4 px-4 py-3">
              <input
                type="checkbox"
                onChange={(e) => {
                  if (e.target.checked) {
                    setSelectedProductIds(products.map((i) => i.recordID));
                  } else {
                    setSelectedProductIds([]);
                  }
                }}
                checked={selectedProductIds.length === products.length}
              />
            </th>
            {selectedProductIds.length > 0 ? (
              <th colSpan={2}>
                <div className="flex items-center space-x-4">
                  <div>{selectedProductIds.length} Selected Products</div>
                  <Button onClick={() => setSelectedProductIds([])} danger>
                    Clear Selection
                  </Button>
                </div>
              </th>
            ) : (
              <>
                <th colSpan={2}>Product ({products.length})</th>
              </>
            )}
            <th className="text-right px-4">Availability</th>
          </tr>
        </thead>
        <tbody>
          {products.map((product, index) => (
            <tr
              key={index}
              className="border-y border-gray-100 dark:border-gray-700"
            >
              <td className="px-4">
                <input
                  type="checkbox"
                  onChange={(e) => {
                    if (e.target.checked) {
                      setSelectedProductIds([
                        ...selectedProductIds,
                        product.recordID,
                      ]);
                    } else {
                      setSelectedProductIds(
                        selectedProductIds.filter(
                          (id) => id !== product.recordID,
                        ),
                      );
                    }
                  }}
                  checked={selectedProductIds.includes(product.recordID)}
                />
              </td>
              <td className="w-14 shrink-">
                {product.primaryImageUrl && (
                  <div className="flex justify-center">
                    <img
                      className="w-full"
                      src={product.primaryImageUrl}
                      alt={product.name}
                    />
                  </div>
                )}
              </td>
              <td className="whitespace-nowrap">
                <div className="flex items-center space-x-2">
                  <div>
                    <span>#{product.recordID}. </span>
                    <span className="font-semibold">{product.itemNumber}</span>
                  </div>
                  <Button
                    danger={!product.odooProduct}
                    onClick={() => chooseProductToLink(product)}
                  >
                    {product.odooProduct ? <FaLink /> : <FaLinkSlash />}
                  </Button>
                </div>

                <div>
                  {product.name}({product.quantityIncrement}) / upc:{" "}
                  {product.upc1}
                </div>
              </td>
              <td className="text-right px-4 space-x-2">
                {product.discontinued && <span>Discontinued</span>}
                <span>
                  {product.isAvailable
                    ? "Available"
                    : product.nextAvailableDate
                      ? product.nextAvailableDate
                      : "Not Available"}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ProductsView;
